export default {"src":"/_next/static/image/public/images/flags/flag_220.ecebbab8adb28a16469bce2b0b4e8e6a.svg","height":16,"width":24};